
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import axios from "axios";
import store from "./store";
import router from "./router";
import VueAxios from "vue-axios";
import Toasted from "vue-toasted";
import Vuelidate from "vuelidate";
import { sync } from "vuex-router-sync";
import Schema from "./assets/js/schema.js";
import Planner from "./assets/js/planner.js";
//import VueHtmlToPaper from "vue-html-to-paper";

// Copied from VueSweetalert2 for browswer compliance issues
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

function isBrowser() {
    return typeof window !== 'undefined';
}

var VueSweetalert2 = {
    install: function(Vue, options) {
        if (!options) {
            options = { toast: false };
        }
        // 1. adding a global method or property
        const _swal = isBrowser() ? swal : function() {};

        Vue.swal = _swal;

        // 4. add the instance method
        Object.defineProperty(Vue.prototype, '$swal', {
            get: function get() {
                return _swal
            }
        });
    }
};


//import css from "../static/css/app.css";

require("bootstrap");
require("bootstrap-datepicker");

Vue.prototype.$bus = new Vue(); // Global event bus
Vue.prototype.$schema = Schema; // Model schema helper
Vue.prototype.$planner = Planner; // App utilities
Planner.init();

// Setup notifications
Vue.use(Toasted, {
    //duration: 3000,
    theme: "outline",
    action: {
        text: 'Close',
        onClick: (e, toastObject) => {
            toastObject.goAway(0);
        }
    }
});

// Moment plugin
Vue.use(require("vue-moment-jalaali"));

// Setup http client
Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.API_BASE_URL;
Vue.axios.defaults.headers.common.Accept = "application/json";

// Custom axios error handler
Vue.axios.interceptors.response.use(
    response => response,
    error => {
        switch (error.response.status) {
            case 401:
                if (router.currentRoute !== "login") {
                    store.dispatch("auth/logout");
                    router.push("/login");
                }
                break;

            case 422:
                _.forOwn(error.response.data.errors, (value, key) => {
                    _.each(value, err => {
                        Vue.toasted.error(err);
                    });
                });
                break;

            default:
                // Default error message
                Vue.toasted.error("An error occured.");
        }

        // Always deactivate busy overlay
        Planner.busy(false);

        return Promise.reject(error);
    }
);

// Guard application routes
router.beforeEach((to, from, next) => {
    // Debugging event output
    // console.log(jQuery._data(jQuery(window).get(0), "events"));

    // If an unauthenticated user trys to visit a restricted page redirect them to the login page.
    if (to.matched.some(m => m.meta.guest)) {
        next();
    } else if (!store.state.auth.authenticated) {
        next({ name: "login" });
    } else if (
        // Here we are making sure there is a role intersection if the page requires special roles to view.
        to.meta.roles &&
        to.meta.roles.filter(
            value => store.state.auth.roles.indexOf(value) !== -1
        ).length === 0
    ) {
        next({ name: "inspections" });
    } else {
        // some other case which should not happen
        next();
    }
});

// Sync store and router
sync(store, router);

// Initialize authentication
store.dispatch("auth/init");

// Validation plugin
Vue.use(Vuelidate);

Vue.use(VueSweetalert2);


// const options = {
//     name: "_blank",
//     specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
//     styles: [
//         "https://demo.pixelcave.com/oneui/assets/css/bootstrap.min-3.0.css",
//         "https://demo.pixelcave.com/oneui/assets/css/oneui.min-3.3.css"
//     ]
// };

// Vue.use(VueHtmlToPaper, options);

/* eslint-disable no-new */
new Vue({
    el: "#app",
    store,
    router,
    template: "<App/>",
    components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js